import { Route } from '@angular/router';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseCardModule } from '@fuse/components/card';
import { FuseAlertModule } from '@fuse/components/alert';
import { SharedModule } from 'app/shared/shared.module';
import { DirectivesModule } from 'app/directives/directive.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { RolesComponent } from './roles.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginatorTranslator } from 'app/components/mat-custom-table/mat-paginator-translator';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';

export const routes: Route[] = [
    {
        path: '',
        component: RolesComponent,
    },
];

@NgModule({
    declarations: [RolesComponent],
    imports: [
        RouterModule.forChild(routes),
        MatIconModule,
        CommonModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        FuseCardModule,
        FuseAlertModule,
        DirectivesModule,
        MatTableModule,
		MatSortModule,
		MatPaginatorModule,
        FuseScrollbarModule
	],
	providers: [
		/* Traducir al español el paginador */
		{
			provide: MatPaginatorIntl,
			useClass: MatPaginatorTranslator
		}
    ],
})
export class RolesModule {}
